<template>
  <div class="gallery">
    <div class="container">
      
      <div class="row justify-content-center">
        <div
          class="col-6"
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="d-flex flex-wrap row justify-content-center">
            <div
              class="col-12"
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}`" />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="control left" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="control right" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{ preview.copyright.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-md-4",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7737_UZjjr2KyEp.jpg",
              transition: "fade-down-right",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7769_642WwbRMQSZQ.jpg",
              transition: "fade-down-right",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/DSCF0889_bV8QMQFyM.jpg",
              transition: "fade-down-right",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7701_JJFBzXJ1YQ.jpg",
              transition: "fade-down-right",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/DSCF0876_YNB5yVAxfH.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
          ],
        },
        {
          className: "col-md-4",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7652_gwS9vOtjN-.jpg",
              transition: "fade-down-left",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7659_y_o_fZQ5MaJB.jpg",
              transition: "fade-down-left",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7775__v7bdlRF-_yZ.jpg",
              transition: "fade-down-left",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7685_D83JGw1DrLxQ.jpg",
              transition: "fade-down-left",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7770_J-n3o2cbFEC.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
          ],
        },
        {
          className: "col-md-4 col-12 full-mobile",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/DSCF0872_4LkvogsI3A.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/DSCF0884_jF_D4q6Df_0W.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7675_e4KsdiD9BKFS.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7711_GAgaFAxua7zF.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_7696_tT5WhxlgaMa.jpg",
              transition: "fade-down-left",
              class: "order-1 order-lg-1",
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/adhi-tita/SKF_0397_e_1bjycdRE.jpg",
              transition: "fade-down-right",
              class: "order-1 order-lg-1",
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
